import React from "react";

interface VehicleCardSkeletonProps {
  rows?: number;
}

const VehicleCardSkeleton: React.FC<VehicleCardSkeletonProps> = ({
  rows = 8,
}) => {
  return (
    <div className="grid grid-cols-3 gap-4">
      {Array.from({ length: rows }).map((_, idx) => (
        <div
          key={idx}
          className="animate-pulse rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 space-y-3 relative overflow-hidden"
        >
          {/* Glow Effect */}
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent" />

          {/* Header */}
          <div className="flex items-start justify-between border-b border-[#D2D2D2]/70 pb-2 relative z-10">
            <div className="space-y-2">
              <div className="h-3 w-16 bg-gray-200 rounded" />
              <div className="h-6 w-32 bg-gray-200 rounded-lg" />
            </div>

            <div className="h-7 w-20 rounded-full bg-gray-200" />
          </div>

          {/* Info Section */}
          <div className="space-y-3 relative z-10">
            {[1, 2, 3].map((item) => (
              <div key={item} className="flex items-center justify-between">
                <div className="h-4 w-20 bg-gray-200 rounded" />
                <div className="h-4 w-24 bg-gray-200 rounded" />
              </div>
            ))}
          </div>

          {/* Button */}
          <div className="relative z-10">
            <div className="h-10 w-full rounded-lg bg-[#FBD037]/20" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default VehicleCardSkeleton;
